import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CoinsStokedIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 14 14" sx={{ height: '14px', width: '14px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M10.4999 3.5L3.49988 10.5M3.49988 3.5L10.4999 10.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default CoinsStokedIcon;
